import mixins from 'vue-typed-mixins';

import StudyMixin from '@/user/mixins/StudyMixin';



export const MAX_TIME_COUNT = 10;

export default mixins(StudyMixin).extend({
  name: 'RestTimeBar',

  data(): {
    maxTimeCount: number
  } {
    return {
      maxTimeCount: MAX_TIME_COUNT
    };
  },

  computed: {
    restTimeCount(): number {
      return Math.ceil(this.questionRestMs / (MAX_TIME_COUNT * 1000));
    }
  }



});
